/**
 * Globo #gf-products: keep featured image visible when Globo swaps to SKU images.
 */
(function () {
  var LIST_SELECTORS = '#gf-products, #gspfProducts, ul.gf-products, ul[data-gf-products], ul[data-gspf-products]';

  function isValidProductImageUrl(url) {
    if (!url || typeof url !== 'string') return false;
    if (url.indexOf('data:image/gif') === 0) return false;
    if (url.indexOf('product-1.png') !== -1) return false;
    return /cdn\.shopify\.com|shopify\.com\/s\/files|\/cdn\/shop\//i.test(url);
  }

  function showMainImage(wrapper, mainImg) {
    if (!wrapper || !mainImg) return;

    mainImg.classList.add('spf-product-card__image-main', 'lazyloaded');
    mainImg.classList.remove('spf-product-card__image-hidden');
    mainImg.style.removeProperty('opacity');
    mainImg.style.removeProperty('visibility');
    mainImg.style.removeProperty('display');

    var featuredSrc = wrapper.getAttribute('data-mt-featured-src');
    if (isValidProductImageUrl(featuredSrc)) {
      mainImg.src = featuredSrc;
      mainImg.setAttribute('src', featuredSrc);
      if (mainImg.hasAttribute('data-src')) {
        mainImg.setAttribute('data-src', featuredSrc);
      }
    }
  }

  function enforceCard(wrapper) {
    if (!wrapper) return;

    var mainImg = wrapper.querySelector('.spf-product-card__image-main');
    if (!mainImg) {
      mainImg = wrapper.querySelector('img.spf-product-card__image');
      if (mainImg) mainImg.classList.add('spf-product-card__image-main');
    }

    if (!mainImg) return;

    showMainImage(wrapper, mainImg);
  }

  function enforceFeaturedMainImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(LIST_SELECTORS).forEach(function (list) {
      list.querySelectorAll('.spf-product-card__image-wrapper').forEach(enforceCard);
    });
  }

  function observeGloboLists() {
    document.querySelectorAll(LIST_SELECTORS).forEach(function (list) {
      if (list.__mtGfFeaturedImageObserved) return;
      list.__mtGfFeaturedImageObserved = true;

      var observer = new MutationObserver(function () {
        window.requestAnimationFrame(function () {
          enforceFeaturedMainImages(list);
        });
      });
      observer.observe(list, { childList: true, subtree: true });
    });
  }

  function boot() {
    enforceFeaturedMainImages(document);
    observeGloboLists();
    window.setTimeout(enforceFeaturedMainImages, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('globoFilterUpdated', boot);
})();
